"use client";
import { motion } from "framer-motion";
import { itemVariants } from "./motion";

export default function StatCard({ stats }) {
  return (
    <motion.div
      variants={itemVariants}
      className="bg-[#005787] text-white p-6 rounded-lg space-y-4 shadow-customHigh h-max w-full md:w-[60%]"
    >
      <div className="flex justify-between items-center">
        <span onClick={() => console.log(stats)} className="text-lg">
          Total Cases
        </span>
        <span className="text-xl font-medium">{stats?.TotalLeads}</span>
      </div>

      <div className="flex justify-between items-center">
        <span className="text-lg">Active Leads</span>
        <span className="text-xl font-medium">{stats?.ActiveLeads}</span>
      </div>

      <div className="flex justify-between items-center">
        <span className="text-lg">Finalized Leads</span>
        <span className="text-xl font-medium">{stats?.FinishedLeads}</span>
      </div>

      {/* <div className="flex justify-between items-center">
        <span className="text-lg">Pending Leads</span>
        <span className="text-xl font-medium">{stats?.PendingLeads}</span>
      </div> */}
    </motion.div>
  );
}
